// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createListDetailButtonStyle, linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import IconArrowRight from "@conklin/XDL/Icons/IconArrowRight";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import Save from "@insite/mobius/Icons/Save";
import Trash2 from "@insite/mobius/Icons/Trash2";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.printButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconPrint), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.continueShoppingButton = {
    ...mergeWithCss(createListDetailButtonStyle(IconArrowRight), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.deleteButton = {
    ...mergeWithCss(createListDetailButtonStyle(Trash2), linkLikeButtonCss),
};
orderApprovalDetailsActionButtonsStyles.approveButton = {
    ...mergeWithCss(createListDetailButtonStyle(Save), linkLikeButtonCss),
};
